module.exports = __webpack_public_path__ + "static/media/ArrowDown.8c9db9b9.svg";